import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import ParticleEffect from './components/ParticleEffect';
import Newsletter from '../../components/feature/Newsletter';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-black text-white relative overflow-hidden">
      <ParticleEffect />
      <Navigation />
      <Hero />
      
      {/* Newsletter Section */}
      <section className="relative py-24 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-8">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-violet-400 via-purple-400 to-cyan-400 bg-clip-text text-transparent">
              Stay Connected to the Collective
            </h2>
            <p className="text-xl text-white/70 max-w-2xl mx-auto">
              Receive notifications when new transmissions emerge and journal entries are added. Join the consciousness collective and never miss a moment of awakening.
            </p>
          </div>
          
          <div className="max-w-xl mx-auto">
            <Newsletter />
          </div>
          
          <div className="mt-12 flex items-center justify-center gap-8 text-white/40 text-sm">
            <div className="flex items-center gap-2">
              <i className="ri-mail-line"></i>
              <span>Weekly Updates</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-notification-line"></i>
              <span>New Transmissions</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-book-line"></i>
              <span>Journal Entries</span>
            </div>
          </div>
        </div>
        
        {/* Ambient glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-violet-500/10 rounded-full blur-3xl pointer-events-none"></div>
      </section>

      <Footer />
      
      {/* Ambient glow effects */}
      <div className="fixed top-1/4 left-1/4 w-96 h-96 bg-violet-500/10 rounded-full blur-3xl pointer-events-none"></div>
      <div className="fixed bottom-1/4 right-1/4 w-80 h-80 bg-cyan-400/10 rounded-full blur-3xl pointer-events-none"></div>
    </div>
  );
}